export default __webpack_public_path__ + "static/media/Sepulcher's Ward.e51e73c6.jpg";